<template>
  <div class="">
    <div class="head-title">分配可用员工</div>
    <el-collapse style="margin-bottom: 2rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            1、分配企业员工需要开启的相关功能，例如：需要会话存档的员工开启会话存档功能后，才会展示聊天数据。
          </p>
          <p>
            2、根据所购买版本套餐，添加会话存档或CRM员工不可以超过购买版本限制人数。
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="mMain">
      <div class="">
        <div class="tianjia">
          <div class="navbse">
            <div class="cut">
              <span @click="contract()" :class="crm == true ? 'a' : ''"
                >SCRM</span
              >
              <span @click="money()" :class="bbb == true ? 'a' : ''"
                >会话存档</span
              >
            </div>
            <span>
              <el-button
                type="primary"
                icon="el-icon-circle-check"
                @click="tijiaoqiyong"
                >启用</el-button
              >
              <el-button
                type="danger"
                icon="el-icon-circle-close"
                @click="tijiaoqiyongs"
                >禁用</el-button
              >
            </span>
          </div>
          <div class="body_book" :key="auto">
            <div class="tree">
              <el-tree
                style="overflow-y: auto"
                :data="tabodata"
                :props="defaultProps"
                :highlight-current="true"
                @node-click="handleNodeClick"
              ></el-tree>
            </div>
            <div>
              <el-table
                :data="liaotjl"
                border
                
                @selection-change="handleSelectionChange"
                :height="height"
              >
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column prop="name" label="员工姓名" align="center">
                </el-table-column>
                <el-table-column prop="is_show" label="是否启用" align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.status == 1" style="color: blue">
                      启用
                    </div>
                    <div v-if="scope.row.status == 2" style="color: red">
                      禁用
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  data() {
    return {
      tableData: {},
      checked: false,
      username: "",
      title: {},
      tooken: "",
      liaotjl: [],
      tabledataneo: [],
      crm: true,
      bbb: false,
      auto: "CRM",
      baseURL: this.axios.defaults.baseURL,
      total: 0,
      tabodata: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      dasues: [],
      arrs: [],
      aaa: {},
      height: 600,
    };
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据 http://192.168.0.149/api/Prive/getPriveList
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    // this.handleNodeClick()
    this.about();
  },
  methods: {
    tijiaoqiyong() {
      if (this.dasues.length) {
        this.axios
          .post(
            "/crm/KpiSet/editAssignUser",
            qs.stringify({
              usertoken: this.tooken.usertoken,
              account_id: this.tooken.account_id,
              type: this.auto,
              phone: this.tooken.phone,
              userid: this.dasues.toString(),
              status: "1",
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.code == 1) {
              this.abcus();
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else if (res.data.code == 0) {
              this.$message.error(res.data.msg);
            }
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
          })
          .catch(function (err) {});
      } else if (!this.dasues.length) {
        this.$message.error("没有选择员工或员工已启用");
      }
    },
    tijiaoqiyongs() {
      if (this.arrs.length) {
        this.axios
          .post(
            "/crm/KpiSet/editAssignUser",
            qs.stringify({
              usertoken: this.tooken.usertoken,
              account_id: this.tooken.account_id,
              type: this.auto,
              phone: this.tooken.phone,
              userid: this.arrs.toString(),
              status: "2",
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.code == 1) {
              this.abcus();
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else if (res.data.code == 0) {
              this.$message.error(res.data.msg);
            }
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
          })
          .catch(function (err) {});
      } else if (!this.dasues.length) {
        this.$message.error("没有选择员工或员工以禁用");
      }
    },
    handleNodeClick(val) {
      this.aaa = val;
      this.abcus();
    },
    abcus() {
      this.axios
        .post(
          "/crm/Assistant/getAddressBooks",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            department: this.aaa.id,
            type: this.auto,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.liaotjl = res.data.data;
        })
        .catch(function (err) {});
    },
    handleSelectionChange(val) {
      let data = [];
      let arr = [];
      val.forEach((item, index) => {
        if (item.status == 2) {
          data.push(item.userid);
        }
        if (item.status == 1) {
          arr.push(item.userid);
        }
      });
      this.dasues = data;
      this.arrs = arr;
    },
    toggleIsShow(item) {
      this.submit(false);
    },
    contract() {
      this.crm = true;
      this.bbb = false;
      this.auto = "CRM";
      this.about();
    },
    money() {
      this.crm = false;
      this.bbb = true;
      this.auto = "session";
      this.about();
    },
    // 页数
    handleCurrentChange(val) {
      this.axios
        .post(
          "/crm/KpiSet/getKpiUsersss",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            page: val,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.liaotjl = res.data.data;
          this.total = res.data.count;
        })
        .catch(function (err) {});
    },
    submit(refresh = true) {
      let a = [];
      for (var i = 0; i <= this.liaotjl.length - 1; i++) {
        if (this.liaotjl[i].is_show) {
          a.push(this.liaotjl[i].userid);
        }
      }
      this.axios
        .post(
          "/crm/KpiSet/editAssignUser",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            type: this.auto,
            userid: a.join(),
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            if (refresh) {
              this.about();
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            }
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
        })
        .catch(function (err) {});
    },
    // 提交过后输出的数据\
    about() {
      this.axios
        .post(
          "/crm/DepartmentSet/getDepartmentList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.tabodata = res.data.data;
          // 使左侧选择部门与右边表格高度保持一致
          this.$nextTick(() => {
            this.height = document.querySelector(".tree").offsetHeight;
          });
        })
        .catch(function (err) {});
      // this.axios
      //   .post(
      //     "/crm/KpiSet/getKpiUsersss",
      //     qs.stringify({
      //       usertoken: this.tooken.usertoken,
      //       account_id: this.tooken.account_id,
      //       phone: this.tooken.phone,
      //     }),
      //     { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
      //   )
      //   .then((res) => {
      //     this.liaotjl = res.data.data;
      //     this.total = res.data.count;
      //     if (res.data.msg == "登录超时") {
      //       this.$router.push("/register");
      //     }
      //     this.selected();
      //   })
      //   .catch(function (err) {});
    },
    selected() {
      this.axios
        .post(
          "/crm/KpiSet/getAssignUser",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            type: this.auto,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.tabledataneo = res.data.data;
          var a = this.liaotjl;
          for (var i = 0; i <= this.liaotjl.length - 1; i++) {
            for (var j = 0; j <= this.tabledataneo.length - 1; j++) {
              if (this.liaotjl[i].name == this.tabledataneo[j].name) {
                a[i].is_show = this.tabledataneo[j].is_show;
              }
            }
          }
          this.liaotjl = a;
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
        })
        .catch(function (err) {});
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
  },

  // 1.用户分配
  // 2.用户分配
  // 3.用户选择 附件管理
};
</script>
<style scoped>
.home {
  width: 100%;
  height: 100%;
}
.body_html {
  width: 100%;
  height: 100%;
}
.wei_body {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
}
.tianjia {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}
.tianjia > main {
  font-size: 2.3rem;
  color: #656565;
  margin-bottom: 2rem;
}
.bule {
  width: 100%;
  height: 6.9rem;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: .0rem;
  left: .0rem;
}
.body_book {
  margin-top: 3rem;
  display: flex;
}
.body_book > div {
  text-align: center;
}
.body_book > div:nth-child(1) {
  width: 30%;
  height: 100%;
  /* height: 59.3rem; */
  min-height: 59.3rem;
  margin-right: 1.2rem;
  border: .1rem solid #f2f3f5;
}
.body_book > div:nth-child(2) {
  width: 70%;
  height: 100%;
  border: .1rem solid #f2f3f5;
}
.cut > span {
  display: inline-block;
  text-align: center;
  cursor: pointer;
  margin: 0 2rem;
  padding: 1rem;
  font-weight: 500;
  font-size: 2.2rem;
}
.a {
  border-bottom: .2rem solid;
  color: #49B372;
}
.staffo_home {
  width: 100%;
  height: 100%;
}
.navbse {
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-bottom: .1rem solid #eee;
}
</style>


